module.exports = __webpack_public_path__ + "img/hand-ok.87b1625d.png";